import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { putProfile, putChangePwd } from "store/actions";
import toastr from "toastr";
// import Cropper, { ReactCropperElement } from "react-cropper";

import { validate, isValidHttpUrl, validZipCode } from "helpers/validations";
import { validatePassword } from "helpers/passwordValidation";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { uploadFile } from "store/actions";
import $ from 'jquery';
import { Oval } from "react-loader-spinner";

export default function Editprofile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dis, disSet] = useState(true);

  const { user, loading } = useSelector((state) => state?.Login);
  // const { loading } = useSelector((state) => state?.File);
  const putloading = useSelector((state) => state?.Profile);
  // const cropperRef = useRef<ReactCropperElement>(null);
  const [images, setimages] = useState({
    profileImage: null,
    bannerImage: null,
  });

  const [passwordtype, setPasswordType] = useState("password");
  const [passwordtype2, setPasswordType2] = useState("password");
  const [passwordtype3, setPasswordType3] = useState("password");
  const [toggle, setToggle] = useState(false);

  const pass = () => {
    if (passwordtype === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const confirmpass = () => {
    if (passwordtype2 === "password") {
      setPasswordType2("text");
      return;
    }
    setPasswordType2("password");
  };
  const confirmpass2 = () => {
    if (passwordtype3 === "password") {
      setPasswordType3("text");
      return;
    }
    setPasswordType3("password");
  };

  const [changepassfields, setChangepassfields] = useState({
    oldPassword: "",
    newPassword: "",
    confirmpassword: ""
  })
  const [museumDescription, setmuseumDescription] = useState("");
  const [text, setText] = useState("");
  const maxCharacterCountmuseum = 2500;
  const maxCharacterCount = 60;
  const [fields, setFields] = useState({
    name: "",
    lastname: "",
    companyName: "",
    museumName: "",
    docs_number: "",
    docs_upload: "",
    docs_link: "",
    email: "",
    jobTitle: "",
    description: "",
    gender: "",
    age: "",
    address: "",
    state: "",
    city: "",
    zip: "",
    country: "",
    mobileNumber: "",
    bio: "",
    website: "",
    socialMedia: "",
    profileImage: null,
    profilePreview: null,
    bannerPreview: null,
    bannerImage: null,
  });

  const {
    name,
    nameError,
    lastname,
    lastnameError,
    companyName,
    companyNameError,
    museumName,
    museumNameError,
    jobTitle,
    jobTitleError,
    docs_number,
    docs_numberError,
    docs_upload,
    docs_uploadError,
    docs_link,
    docs_linkError,
    description,
    descriptionError,
    email,
    emailError,
    gender,
    genderError,
    age,
    ageError,
    address,
    state,
    city,
    zip,
    country,
    socialMedia,
    addressError,
    stateError,
    cityError,
    zipError,
    countryError,
    website,
    websiteError,
    mobileNumber,
    mobileNumberError,
    bio,
    bioError,
  } = fields;

  const {
    oldPassword,
    oldPasswordError,
    newPassword,
    newPasswordError,
    confirmpassword,
    confirmpasswordError
  } = changepassfields;

  const uploadFileSuccess = (name) => (response) => {
    const { _id, link, message } = response.data;
    setFields((prev) => ({ ...prev, [name]: _id }));
    onChangeHandler(name)({ target: { value: _id } });
    if (name == "media") setFields((prev) => ({ ...prev, imgType: link }));
    return toastr.success("Image uploaded successfully!");

  };

  const handleImageChange = (name) => (evt) => {
    const image = evt.target.files;
    const ext = image[0].name.split(".").pop();

    if (ext !== "png" && ext !== "jpg" && ext !== "jpeg") {
      return toastr.error("Only png, jpg, extensions allowed");
    }
    if (image[0] && image[0].size >= 1.04e6 + 24) {
      toastr.error("Please upload a file smaller than 1 MB");
      return false;
    }

    if (image && image[0]) {
      dispatch(uploadFile({ image: image[0] }, uploadFileSuccess(name)));
      setFields((prevState) => ({
        ...prevState,
        ...(name === "bannerImage"
          ? {
            bannerPreview: URL.createObjectURL(image[0]),
            bannerImageRaw: image[0],
            bannerName: image[0].name,
          }
          : {
            profilePreview: URL.createObjectURL(image[0]),
            profileImageRaw: image[0],
            profileImageName: image[0].name,
          }),
      }));
    }
  };
  const uploadDocsSuccess = (name) => (response) => {
    const { _id, link, message } = response.data;

    setFields((prev) => ({ ...prev, docs_link: _id }));

    toastr.success(message);
    onChangeHandler(name)({ target: { value: _id } });
    if (name == "media") setFields((prev) => ({ ...prev, docsType: link }));
  };
  const handleDocsChange = (name) => (evt) => {
    const docs = evt.target.files;
    if (docs[0] && docs[0].size >= 1.04e6 + 24) {
      toastr.error("Please upload document smaller than 1 MB");
      return false;
    }
    if (docs && docs[0]) {
      // console.log("docs upload " ,docs[0])
      dispatch(uploadFile({ image: docs[0] }, uploadDocsSuccess("media")));
      setFields((prevState) => ({
        ...prevState,
        docs_upload: docs[0].name

      })
      )

    }
  };

  const onChangeHandler = (e) => {
    e.persist();
    const { value, name } = e.target;
   
    if ((name == 'address') && (value.length <= maxCharacterCount)) {
      setText(value);
    }
    if ((name == 'description') && (value.length <= maxCharacterCountmuseum)) {
      setmuseumDescription(value);
    }
    setFields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );
  };

  const onChangepassHandler = (e1) => {
    // e1.persist();
    e1.preventDefault();
    const { value, name } = e1.target;
    setChangepassfields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );

  }

  const onChangepassCancel = (e) => {
    setChangepassfields({ oldPassword: "", newPassword: "", confirmpassword: "" });
    $('.changepasswordprofile').removeClass('active')
    $('.passwordBox').slideUp()
  }

  const onChangepassSubmit = (e) => {

    e.preventDefault();
    // console.log("e changepass",e)
    const resp = validate(changepassfields);
    setChangepassfields((prev) => ({ ...prev, ...resp }));

    // if (!isValidHttpUrl(fields?.website)) {
    //   toast.error("URL is not valid.");
    //   return;
    // }
    if (changepassfields?.oldPassword.trim() === "") {
      return toastr.error("Old password is required");
    }
    if (changepassfields?.newPassword.trim() === "") {
      return toastr.error("New password is required");
    }


    if (!validatePassword(changepassfields?.newPassword)) {
      toastr.error("Password should be a minimum of 6 characters, it must include a lower case, upper case and a special character along with a number.");
      return;
    }


    if (changepassfields?.confirmpassword.trim() === '') {
      return toastr.error("Confirm password is required");
    }

    if (changepassfields?.newPassword !== changepassfields?.confirmpassword) {
      return toastr.error("Confirm password does not match");
    }


    let passdata = {
      oldPassword: changepassfields?.oldPassword,
      newPassword: changepassfields?.newPassword,
      confirmpassword: changepassfields?.confirmpassword,
    };
    //console.log("changepass data",passdata);
    const callback1 = (response1) => {
      const { message, status } = response1;
      //  console.log("callback",response1)
      if (status === "failure") {
        return toastr.error(message);
      } else {
        setChangepassfields({ oldPassword: "", newPassword: "", confirmpassword: "" });
        return toastr.success("Your password has been changed successfully");
        //  console.log(response);

        // disSet(true);
        // console.log(dis);
        // navigate("../home");
      }
    };
    // if (!resp?.notValid) {
    dispatch(putChangePwd(passdata, callback1));
    // }
  };


  const onSubmit = (e) => {
    disSet(true);
    // console.log(dis);
    e.preventDefault();
    const resp = validate(fields);
    setFields((prev) => ({ ...prev, ...resp }));

    // if (!isValidHttpUrl(fields?.website)) {
    //   toast.error("URL is not valid.");
    //   return;
    // }
    //  user?.museumName
    //   user?.jobTitle
    //   user?.docs_number 
    //   user?.docs_upload
   
      if (fields?.website && !fields?.website.startsWith("https://")) {
        disSet(false);
        return toastr.error("Website must start with https://");; // Prevent further action
      }
    
    if (user.role === "MUSEUM") {
      if (fields?.museumName.trim() === "") {
        disSet(false);
        return toastr.error("Museum name is required");
      }
      if (fields?.name.trim() === "") {
        disSet(false);
        return toastr.error("Contact person name is required");
      }
      if (fields?.jobTitle.trim() === "") {
        disSet(false);
        return toastr.error("Job title is required");
      }
    }

    if (user.role !== "MUSEUM") {
      if (fields?.name.trim() === "") {
        disSet(false);
        return toastr.error("Name is required");
      }
      if (fields?.lastname.trim() === "") {
        disSet(false);
        return toastr.error("Last name is required");
      }
    }
    if (fields?.mobileNumber?.length < 10) {
      disSet(false);
      return toastr.error("Phone number must be at least 10 numbers");
    }
    if (fields?.address.trim() === "") {
      disSet(false);
      return toastr.error("Address is required");
    }
    if (fields?.state.trim() === "") {
      disSet(false);
      return toastr.error("State is required");
    }
    if (fields?.city.trim() === "") {
      disSet(false);
      return toastr.error("City is required");
    }
    if (fields?.zip.trim() === "") {
      disSet(false);
      return toastr.error("Zip code is required");
    }
    if (!validZipCode(fields?.zip)) {
       disSet(false);
      return toastr.error("Special characters are not allowed in zip code")
    }
    if (fields?.country.trim() === "") {
      disSet(false);
      return toastr.error("Country is required");
    }

    if (user.role !== "MUSEUM") {
      // if (fields?.companyName === "") {
      //   return toastr.error("Company Name is Required");
      // }
      if (fields?.gender.trim() === "") {
        disSet(false);
        return toastr.error("Gender is required");
      }
      if (fields?.age.trim() === "") {
        disSet(false);
        return toastr.error("Age is required");
      }
      if (fields?.age < 18) {
        disSet(false);
        return toastr.error("Age should be minimum 18 year");
      }
    }


    if (user.role.trim() === "MUSEUM") {
      if (fields?.docs_number.trim() === "") {
        disSet(false);
        return toastr.error("Document number is required");
      }
      if (fields?.docs_upload.trim() === "") {
        disSet(false);
        return toastr.error("Please upload the document");
      }
      if (fields?.description.trim() === "") {
        disSet(false);
        return toastr.error("Description is required");
      }
      if (validZipCode(fields?.zipcode)) {
        return toastr.error("Special characters are not allowed")
      }
    }

    // if (!fields?.bio) {
    //   return toast.error("Bio Required");
    // }

    let data = {
      name: fields?.name?.trim(),
      lastname: fields?.lastname?.trim(),
      companyName: fields?.companyName?.trim(),
      museumName: fields?.museumName?.trim(),
      jobTitle: fields?.jobTitle,
      docs_number: fields?.docs_number,
      docs_upload: fields?.docs_upload,
      docs_link: fields?.docs_link,
      mobileNumber: fields?.mobileNumber,
      gender: fields?.gender,
      age: fields?.age,
      bio: fields?.bio,
      website: fields?.website,
      address: fields?.address?.trim(),
      state: fields?.state?.trim(),
      city: fields?.city?.trim(),
      zipcode: fields?.zip,
      country: fields?.country,
      description: fields?.description?.trim(),
      socialMedia: fields?.socialMedia,
      profileImage: fields?.profileImage,
      bannerImage: fields?.bannerImage,
    };
    // console.log(data);
    const callback = (response) => {
      const { message, status } = response;
      if (status === "failure") {
        disSet(false);
        return toastr.error(message);
      } else {
        disSet(true);
        return toastr.success("Your profile has been updated successfully");
        //  console.log(response);
        navigate("../home");
      }
    };
    // if (!resp?.notValid) {
    dispatch(putProfile(data, callback));
    // }
  };

  useEffect(() => {
    if (user) {
      // console.log("user yaha aya", user)
      setFields((prevState) => ({
        ...prevState,
        name: user?.name,
        lastname: user?.lastname,
        companyName: user?.companyName,
        museumName: user?.museumName,
        jobTitle: user?.jobTitle,
        docs_number: user?.docs_number,
        docs_upload: user?.docs_upload,
        docs_link: user?.docs_link,
        description: user?.description,
        email: user?.email,
        address: user?.address,
        state: user?.state,
        city: user?.city,
        zip: user?.zipcode,
        country: user?.country,
        mobileNumber: user?.mobileNumber,
        bio: user?.bio,
        website: user?.website,
        profileImage: user?.profileImage?._id,
        bannerImage: user?.bannerImage?._id,
        gender: user?.gender,
        age: user?.age,
        socialMedia: user?.socialMedia,
      }));

      setimages({
        profileImage: user?.profileImage?.link,
        bannerImage: user?.bannerImage?.link,
      });
    }
  }, [user]);

  function editpage() {

    disSet(false);

  }

  // useEffect(()=>{ 

  //   $('.passwordBox').hide()


  //   },[])

  const chnagepass = () => {
    $('.changepasswordprofile').toggleClass('active')
    $('.passwordBox').slideToggle()

    // setToggle(!toggle)
  }
  const profileEdit = () => {


    setText(user?.address)
    setmuseumDescription(user?.description)
    disSet(false)
  }
 
  useEffect(()=>{
    document.querySelectorAll('textarea').forEach((el)=>{
      el.style.height = el.setAttribute('style', 'height: ' + el.scrollHeight + 'px');
      el.classList.add('auto');
      el.addEventListener('input', e =>{
        el.style.height = 'auto';
        el.style.height = (el.scrollHeight) + 'px';
      })
      el.style.height = (el.scrollHeight) + 'px';
      // console.log('height',  el.style.height);
    });
  },[fields?.description, fields?.address])

  return (
    <>
      {loading  &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <div>
              <h1 className="mb-0">
                {dis === true ? "View Profile " : "Edit Profile"}
              </h1>
              {/* {dis === false && (
                <p className="mb-0 mt-2">
                  Easy & simpple way to edit your profile
                </p>
              )} */}
            </div>
            {dis === true && (
              <button
                className="btn btn-primary text-white fw-semibold px-5"
                type="button"
                onClick={profileEdit}
              >

                <i className="fa-light fa-pen-to-square"></i> Edit Profile
              </button>
            )}
          </div>
        </Col>
        <Col lg={12} className="mb-5">
          <div className="profileBoxMaineNew">
            <div className="coverPhotoBox">
              <img src={
                fields?.bannerPreview ||
                user?.bannerImage?.link ||
                "../../images/newpng/newback.png"
                // "../../images/svg/profilehomeImg.svg"
              } className="coverphoto" alt="cover" />
              {dis === false && (
                <Label
                  htmlFor="uploadcover"
                  className="btn uploadprofilebtn text-white btn-sm py-2 coverupload"
                >
                  <i className="fa-light fa-pen-to-square"></i>  Update Cover Picture
                </Label>
              )}
              <Input hidden type="file" id="uploadcover" onChange={handleImageChange("bannerImage")} />
              <div className="d-flex align-items-center profilePicture gap-4">
                <div className="usewr-imghere">
                  <img
                    src={
                      fields?.profilePreview ||
                      user?.profileImage?.link ||
                      "/images/avatar.png"
                    }
                    alt="profileImage"
                    className="profile-img"
                  />
                  <input
                    type="file"
                    className="d-none"
                    id="profile"
                    onChange={handleImageChange("profileImage")}
                  />
                </div>
                {dis === false && (
                  <div>
                    <label
                      className="btn btn-primary text-white uploadprofilebtn px-4"
                      htmlFor="profile"
                    >
                      <i className="fa-light fa-pen-to-square"></i>  Update Profile Picture
                    </label>
                    <p className="pdecription mt-2 mb-0">
                      JPG, PNG and cannot exceed 1MB.
                    </p>
                  </div>
                )}
              </div>
            </div>
            <Row>
              {user.role !== "MUSEUM" && (
                <>
                  <Col lg={6}>
                    <FormGroup className="form-group position-relative mb-4">
                      <Label className="mb-1">First Name</Label>
                      <Input
                        type="text"
                        name="name"
                        disabled={dis}
                        value={name}
                        invalid={nameError}
                        required={nameError}
                        onChange={onChangeHandler}
                        placeholder="First Name"
                        maxLength={30}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="form-group position-relative mb-4">
                      <Label className="mb-1">Last Name</Label>

                      <Input
                        type="text"
                        name="lastname"
                        disabled={dis}
                        value={lastname}
                        invalid={lastnameError}
                        required={lastnameError}
                        onChange={onChangeHandler}
                        placeholder="Last Name"
                        maxLength={30}
                      />
                    </FormGroup>
                  </Col>
                </>
              )}
              {user.role === "MUSEUM" && (
                <>
                  <Col lg={12}>
                    <FormGroup className="form-group position-relative mb-4">
                      <Label className="mb-1">Museum Name</Label>
                      <Input
                        type="text"
                        name="museumName"
                        disabled={dis}
                        value={museumName}
                        invalid={museumNameError}
                        required={museumNameError}
                        onChange={onChangeHandler}
                        placeholder="Contact Person Name"
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="form-group position-relative mb-4">
                      <Label className="mb-1">Contact Person Name</Label>

                      <Input
                        type="text"
                        name="name"
                        disabled={dis}
                        value={name}
                        invalid={nameError}
                        required={nameError}
                        onChange={onChangeHandler}
                        placeholder="Contact Person Name"
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="form-group position-relative mb-4">
                      <Label className="mb-1">Contact Person Title</Label>

                      <Input
                        type="text"
                        name="jobTitle"
                        disabled={dis}
                        value={jobTitle}
                        invalid={jobTitleError}
                        required={jobTitleError}
                        onChange={onChangeHandler}
                        placeholder="Contact Person Title"
                      />
                    </FormGroup>
                  </Col>
                </>
              )}

              {user.role === "ARTIST" && (
                <Col lg={12}>
                  <FormGroup className="form-group position-relative mb-4">
                    <Label className="mb-1">Company Name</Label>

                    <Input
                      type="text"
                      name="companyName"
                      disabled={dis}
                      value={companyName ? companyName : dis === true ? 'N/A':''}
                      // invalid={companyNameError}
                      // required={companyNameError}
                      onChange={onChangeHandler}
                      placeholder="Company Name"
                    />
                  </FormGroup>
                </Col>
              )}
              <Col lg={6}>
                <FormGroup className="form-group position-relative mb-4">
                  <Label className="mb-1">Phone Number</Label>

                  <Input
                    type="number"
                    disabled={dis}
                    name="mobileNumber"
                    max={13}
                    value={mobileNumber}
                    invalid={mobileNumberError}
                    required={mobileNumberError}
                    onChange={onChangeHandler}
                    placeholder="Phone Number"
                  />
                </FormGroup>
              </Col>
              <Col lg={6}>
                <FormGroup className="form-group position-relative mb-4">
                  <Label className="mb-1">Email</Label>

                  <Input
                    type="email"
                    name="email"
                    disabled
                    value={email}
                    invalid={emailError}
                    required={emailError}
                    onChange={onChangeHandler}
                    placeholder="Email"
                  />
                </FormGroup>
              </Col>
              {(user.role === "ARTIST" || user.role === "USER") && (
                <>
                  <Col lg={6} md={12} sm={12}>
                    <FormGroup className="form-group position-relative">
                      <Label className="mb-1">Gender</Label>

                      <Input
                        type={dis ? 'text' : 'select'}
                        className={"form-control " + (dis ? '' : 'form-select')}
                        disabled={dis}
                        name="gender"
                        max={13}
                        value={gender}
                        invalid={genderError}
                        required={genderError}
                        onChange={onChangeHandler}
                      // required={fieldsError?.genderError}
                      >
                        <option value="" disabled selected>
                          Select Gender
                        </option>
                        <option value={"Male"}>Male</option>
                        <option value={"Female"}>Female </option>
                        <option value={"Prefer Not to Say"}>
                          Prefer Not to Say{" "}
                        </option>
                        {/* <option> Non-Binary </option> */}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col lg={6} md={12} sm={12}>
                    <FormGroup className="form-group position-relative">
                      <Label className="mb-1">Age</Label>

                      <Input
                        type="number"
                        name="age"
                        disabled={dis}
                        onChange={onChangeHandler}
                        value={age}
                        required={ageError}
                        placeholder="Age"
                      />
                    </FormGroup>
                  </Col>
                </>
              )}

              <Col lg={12}>
                <FormGroup className="form-group position-relative mb-4">
                  <Label className="mb-1">Address</Label>

                  <Input
                    type="textarea"
                    name="address"
                    disabled={dis}
                    value={address}
                    maxLength={60}
                    invalid={addressError}
                    required={addressError}
                    onChange={onChangeHandler}
                    placeholder="Address"
                  />
                  {dis === false && <div className="addresmsg position-absolute bottom-0 end-0">
                    {maxCharacterCount - text.length}/
                    {maxCharacterCount}
                  </div>}
                </FormGroup>
              </Col>
              <Col lg={4}>
                <FormGroup className="form-group position-relative mb-4">
                  <Label className="mb-1">State</Label>

                  <Input
                    type="text"
                    name="state"
                    value={state}
                    disabled={dis}
                    invalid={stateError}
                    required={stateError}
                    onChange={onChangeHandler}
                    placeholder="State"
                  />
                </FormGroup>
              </Col>
              <Col lg={4}>
                <FormGroup className="form-group position-relative mb-4">
                  <Label className="mb-1">City</Label>

                  <Input
                    type="text"
                    name="city"
                    value={city}
                    disabled={dis}
                    invalid={cityError}
                    required={cityError}
                    onChange={onChangeHandler}
                    placeholder="City"
                  />
                </FormGroup>
              </Col>
              <Col lg={4}>
                <FormGroup className="form-group position-relative mb-4">
                  <Label className="mb-1">Zip</Label>

                  <Input
                    type="text"
                    name="zip"
                    value={zip}
                    disabled={dis}
                    invalid={zipError}
                    required={zipError}
                    onChange={onChangeHandler}
                    placeholder="Zip"
                  />
                </FormGroup>
              </Col>
              <Col lg={12}>
                <FormGroup className="form-group position-relative mb-4">
                  <Label className="mb-1">Country</Label>

                  <Input
                    type={dis ? 'text' : 'select'}
                    className={"form-control " + (dis ? '' : 'form-select')}
                    name="country"
                    value={country}
                    disabled={dis}
                    invalid={countryError}
                    required={countryError}
                    onChange={onChangeHandler}
                    placeholder="Country"
                  >
                    <option value="" disabled selected>Country</option>
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Andorra">Andorra</option>
                    <option value="Angola">Angola</option>
                    <option value="Anguilla">Anguilla</option>
                    <option value="Antigua">Antigua</option>
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>

                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Brazil">Brazil</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Brazil">Brazil</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bermuda">Bermuda</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                    <option value="Botswana">Botswana</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burundi">Burundi</option>

                    <option value="Bonaire, Sint Eustatius and Saba">Bonaire, Sint Eustatius and Saba</option>
                    <option value="British Virgin Islands">British Virgin Islands</option>
                    <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                    <option value="Brunei">Brunei</option>

                    <option value="Côte d'Ivoire">Côte d'Ivoire</option>
                    <option value="Central African Republic">Central African Republic</option>
                    <option value="China">China</option>
                    <option value="Chad">Chad</option>
                    <option value="Chile">Chile</option>
                    <option value="Curaçao">Curaçao</option>
                    <option value="Croatia">Croatia</option>
                    <option value="Cape Verde">Cape Verde</option>
                    <option value="Colombia">Colombia</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Canada">Canada</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cook Islands">Cook Islands</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Cayman Islands">Cayman Islands</option>
                    <option value="Comoros">Comoros</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominican Republic">Dominican Republic</option>
                    <option value="Dominica">Dominica</option>
                    <option value="Democratic Republic of the Congo">Democratic Republic of the Congo</option>
                    <option value="Egypt">Egypt</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Ecuador">Ecuador</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="France">France</option>
                    <option value="French Guiana">French Guiana</option>
                    <option value="French Polynesia">French Polynesia</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="Falkland Islands">Falkland Islands</option>
                    <option value="Faroe Islands">Faroe Islands</option>
                    <option value="Federated States of Micronesia">Federated States of Micronesia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Greenland">Greenland</option>
                    <option value="Guadeloupe">Guadeloupe</option>
                    <option value="Guam">Guam</option>
                    <option value="Guernsey">Guernsey</option>
                    <option value="Guyana">Guyana</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Gabon">Gabon</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Greece">Greece</option>
                    <option value="Gibraltar">Gibraltar</option>
                    <option value="Guinea-Bissau">Guinea-Bissau</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Honduras">Honduras</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="Isle Of Man">Isle Of Man</option>
                    <option value="Iran">Iran</option>
                    <option value="Italy">Italy</option>
                    <option value="Iraq">Iraq</option>
                    <option value="India">India</option>
                    <option value="Israel">Israel</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Jersey">Jersey</option>
                    <option value="Japan">Japan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kiribati">Kiribati</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kosovo">Kosovo</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libya">Libya</option>
                    <option value="Latvia">Latvia</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Laos">Laos</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Liechtenstein">Liechtenstein</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Macau">Macau</option>
                    <option value="Maldives">Maldives</option>
                    <option value="Malta">Malta</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Montenegro">Montenegro</option>
                    <option value="Mali">Mali</option>
                    <option value="Macedonia">Macedonia</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Martinique">Martinique</option>
                    <option value="Mayotte">Mayotte</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montserrat">Montserrat</option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Moldova">Moldova</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Monaco">Monaco</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Mozambique">Mozambique</option>
                    <option value="Madagascar">Madagascar</option>
                    <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="North Korea">North Korea</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="New Caledonia">New Caledonia</option>
                    <option value="Norway">Norway</option>
                    <option value="Nauru">Nauru</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Niger">Niger</option>
                    <option value="Norfolk Island">Norfolk Island</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Niue">Niue</option>
                    <option value="Oman">Oman</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Peru">Peru</option>
                    <option value="Palau">Palau</option>
                    <option value="Poland">Poland</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Panama">Panama</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Palestine">Palestine</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Republic of the Congo">Republic of the Congo</option>
                    <option value="Russia">Russia</option>
                    <option value="Réunion">Réunion</option>
                    <option value="Rwanda">Rwanda</option>
                    <option value="Romania">Romania</option>
                    <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                    <option value="Saint Helena">Saint Helena</option>
                    <option value="Saint Martin">Saint Martin</option>
                    <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                    <option value="Sint Maarten">Sint Maarten</option>
                    <option value="San Marino">San Marino</option>
                    <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="Slovakia">Slovakia</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Swaziland">Swaziland</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="South Africa">South Africa</option>
                    <option value="South Sudan">South Sudan</option>
                    <option value="Samoa">Samoa</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Sierra Leone">Sierra Leone</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Saint Barthélemy">Saint Barthélemy</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Solomon Islands">Solomon Islands</option>
                    <option value="Somalia">Somalia</option>
                    <option value="Saint Lucia">Saint Lucia</option>
                    <option value="South Korea">South Korea</option>
                    <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Syria">Syria</option>
                    <option value="Spain">Spain</option>
                    <option value="The Bahamas">The Bahamas</option>
                    <option value="The Gambia">The Gambia</option>
                    <option value="Timor-Leste">Timor-Leste</option>
                    <option value="Taiwan">Taiwan</option>
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Tanzania">Tanzania</option>
                    <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                    <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                    <option value="Tunisia">Tunisia</option>
                    <option value="Tuvalu">Tuvalu</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Tokelau">Tokelau</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Togo">Togo</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Arab Emirates">United Arab Emirates</option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="United States">United States</option>
                    <option value="Uruguay">Uruguay</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Vatican City">Vatican City</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Vanuatu">Vanuatu</option>
                    <option value="Vietnam">Vietnam</option>
                    <option value="Wallis and Futuna">Wallis and Futuna</option>
                    <option value="Western Sahara">Western Sahara</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
                  </Input>
                </FormGroup>
              </Col>
              {user.role === "MUSEUM" && (
                <>
                  <Col lg={6}>
                    <FormGroup className="form-group position-relative mb-4">
                      <Label className="mb-1">Document Number</Label>

                      <Input
                        type="text"
                        name="docs_number"
                        disabled={dis}
                        value={docs_number}
                        invalid={docs_numberError}
                        required={docs_numberError}
                        onChange={onChangeHandler}
                        placeholder="Document Number"
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    {dis === true ? (
                      <>
                        <FormGroup className="form-group position-relative">
                          <Label className="mb-1 d-block">&nbsp;</Label><a className="btn btn-primary px-4" href={user?.docs_link?.link} rel="noreferrer">View</a>
                        </FormGroup>
                      </>
                    ) : (
                      <FormGroup className="form-group position-relative">
                        <Label className="mb-1">Upload Document</Label>
                        <div className="position-relative">
                          <Input
                            type="text"
                            placeholder="Upload Document"
                            name="docs_upload"
                            id="docs_upload" className="pe-5"
                            value={docs_upload}
                            invalid={docs_uploadError}
                            required={docs_uploadError}
                            onChange={onChangeHandler}
                            disabled
                          />
                          <Input className="d-none"
                            type="file"
                            disabled={dis}
                            name="docs_link"
                            id="docs_link"
                            invalid={docs_linkError}
                            required={docs_linkError}
                            onChange={handleDocsChange('docs_link')}
                          // accept="image/*"

                          />
                          <label className="btn position-absolute end-0 top-0 bottom-0 border-0 inpicon" htmlFor="docs_link"><i className="fa-light fa-arrow-up-from-bracket text-danger"></i></label>

                        </div>

                      </FormGroup>
                    )}

                  </Col></>)
              }
              {(user.role === "ARTIST" || user.role === "MUSEUM") && (
                <>
                  {" "}
                  <Col lg={12} md={12} sm={12}>
                    <FormGroup className="form-group position-relative">
                      <Label className="mb-1">Website</Label>

                      <Input
                        type="url"
                        id="url"
                        name="website"
                        placeholder="https://www.example.com"
                        value={website}
                        disabled={dis}
                        onChange={onChangeHandler}
                      />
                    </FormGroup>
                  </Col>
                  {/* <Col lg={6} md={12} sm={12}>
                    <FormGroup className="form-group position-relative">
                      <Label className="mb-1">Social Media</Label>

                      <Input
                        type="url"
                        id="url"
                        disabled={dis}
                        name="socialMedia"
                        placeholder=""
                        value={socialMedia}
                        onChange={onChangeHandler}
                      />
                    </FormGroup>
                  </Col> */}
                </>
              )}

              <Col lg={12} >
                <FormGroup className="form-group position-relative">
                  <Label className="mb-1">Description / Biography</Label>

                  <Input type="textarea"
                    maxLength={2500}
                    disabled={dis}
                    placeholder="Description / Biography"
                    name="description"
                    id="description"
                    value={description}
                    invalid={descriptionError}
                    required={descriptionError}
                    onChange={onChangeHandler}
                  />
                  {dis === false &&  <div className="addresmsg position-absolute bottom-0 end-0">
                    {maxCharacterCountmuseum - museumDescription?.length}/
                    {maxCharacterCountmuseum}
                  </div> }
                  {/* <Label for="name">Full Name <span className="col-red">*</span></Label> */}
                </FormGroup>
              </Col>

              {dis === false && (
                <Col lg={12} className="mt-3">
                  <div className="text-start">
                    <button
                      type="submit"
                      className="btn btn-dark px-5"
                      onClick={(e) => onSubmit(e)}
                    >
                      Save Changes{" "}
                      {putloading?.loading ? (
                        <Spinner size="sm" animation="border" role="status"></Spinner>
                      ) : (
                        ""
                      )}
                    </button>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </Col>

        {dis === false && (
          <Col className="mb-3" lg={12}>
            <div className="profileBoxMaineNew py-4">
              <div className="d-flex align-items-center justify-content-between">
                <h1 className="mb-0">Change Password</h1>
                <button onClick={chnagepass} className="btn changepasswordprofile border-0 py-1">
                  <i className="fa-regular fa-chevron-down"></i>
                </button>
              </div>

              <Row className="passwordBox mt-3">
                <Col lg={6}>
                  <FormGroup className="position-relative ">
                    <Input
                      type={passwordtype}
                      className="inputwithicon pe-5 ps-3"
                      name="oldPassword"

                      value={changepassfields?.oldPassword}
                      invalid={changepassfields.oldPasswordError}
                      required={changepassfields.oldPasswordError}
                      placeholder="Old Password"
                      onChange={onChangepassHandler}
                    />
                    {/* <div className="btn position-absolute top-0 start-0 bottom-0 my-auto">
            <i className="fa-regular fa-lock-keyhole"></i>
          </div> */}
                    <button
                      type="button"
                      onClick={pass}
                      className="btn position-absolute top-0 end-0 bottom-0 my-auto border-0 inpicon"
                    >
                      {passwordtype === "password" ? (
                        <i className="fa-light fa-eye-slash"></i>
                      ) : (
                        <i className="fa-light fa-eye"></i>
                      )}
                    </button>
                  </FormGroup>

                  <FormGroup className="position-relative ">
                    <Input
                      type={passwordtype2}
                      className="inputwithicon pe-5 ps-3"
                      name="newPassword"

                      value={changepassfields?.newPassword}
                      invalid={changepassfields.newPasswordError}
                      required={changepassfields.newPasswordError}
                      placeholder="New Password"
                      onChange={onChangepassHandler}
                    />
                    {/* <div className="btn position-absolute top-0 start-0 bottom-0 my-auto">
            <i className="fa-regular fa-lock-keyhole"></i>
          </div> */}
                    <button
                      type="button"
                      onClick={confirmpass}
                      className="btn position-absolute top-0 end-0 bottom-0 my-auto border-0 inpicon"
                    >
                      {passwordtype2 === "password" ? (
                        <i className="fa-light fa-eye-slash"></i>
                      ) : (
                        <i className="fa-light fa-eye"></i>
                      )}
                    </button>
                  </FormGroup>
                  <FormGroup className="position-relative ">
                    <Input
                      type={passwordtype3}
                      className="inputwithicon pe-5 ps-3"
                      name="confirmpassword"

                      value={changepassfields?.confirmpassword}
                      invalid={changepassfields.confirmpasswordError}
                      required={changepassfields.confirmpasswordError}
                      placeholder="Confirm Password"
                      onChange={onChangepassHandler}
                    />
                    {/* <div className="btn position-absolute top-0 start-0 bottom-0 my-auto">
            <i className="fa-regular fa-lock-keyhole"></i>
          </div> */}
                    <button
                      type="button"
                      onClick={confirmpass2}
                      className="btn position-absolute top-0 end-0 bottom-0 my-auto border-0 inpicon"
                    >
                      {passwordtype3 === "password" ? (
                        <i className="fa-light fa-eye-slash"></i>
                      ) : (
                        <i className="fa-light fa-eye"></i>
                      )}
                    </button>
                  </FormGroup>

                </Col>
                <Col lg={12}>
                  <div className="passInt">
                    {/* <p>In order to protect your account, make sure password:</p>
                  <ul>
                    <li>In Longer then 6 character</li>
                    <li>Does not match or significantly contain yourusername, e.g. do not use 'username12'</li>

                  </ul> */}
                    <button className="btn savebtn px-4" onClick={(e) => onChangepassSubmit(e)}>Change Password</button>
                    <button className="btn border-0 ms-3 cancelbtn px-4" onClick={(e) => onChangepassCancel(e)}>Cancel</button>

                  </div>

                </Col>
              </Row>
            </div>
          </Col>
        )}




      </Row>


    </>
  );
}
